import { useState, useEffect } from "react";
import io from "socket.io-client";
import DriverIcon from "../assets/ic_marker_driver.svg";

type MapType = {
  id: string;
  coordinates: [number, number];
  icon?: string;
};

const getSocket = () => {
  return io(process.env.REACT_APP_BASE_URL as string);
};

export const useRideSocket = (rideId?: number) => {
  const [driverMapMarker, setDriverMapMarker] = useState<MapType | null>(null);

  useEffect(() => {
    if (!rideId) return;

    const socket = getSocket();

    socket.connect();

    socket.on("connect", () => {
      console.log("Socket connected for ride", rideId);
      socket.emit("join", `ride_${rideId}`);
    });

    socket.on("connect_error", (error: any) => {
      console.error("Socket connect error:", error);
    });

    socket.on("update_ride_driver_location", (data: any) => {
      if (data) {
        const lat = data.latitude;
        const lng = data.longitude;
        console.log("Received driver location update", data);
        setDriverMapMarker({
          id: "driver",
          coordinates: [lat, lng],
          icon: DriverIcon,
        });
      }
    });

    socket.on("disconnect", (reason: any) => {
      console.warn("Socket disconnected:", reason);
    });

    return () => {
      socket.disconnect();
      console.log("Socket disconnected");
    };
  }, [rideId]);

  return driverMapMarker;
};
